/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Skąd pochodzi zmiana: ręczna edycja w UI, narzędzie czatu AI albo zadanie systemowe.
 * @export
 * @enum {string}
 */

export const DevelopmentPathChangeSourceDto = {
    Manual: 'MANUAL',
    AiChat: 'AI_CHAT',
    System: 'SYSTEM'
} as const;

export type DevelopmentPathChangeSourceDto = typeof DevelopmentPathChangeSourceDto[keyof typeof DevelopmentPathChangeSourceDto];



